import Countdown, { CountdownProps } from "react-countdown";

export default function PromineoCountDownTimer(props: CountdownProps) {
  return <Countdown {...props} />;
}
